import React from 'react';
import {Button, Modal, TextField, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import {baseUrl_back} from "../../api/BaseUrl";
import BackServer from "../../api/BackServer";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#4f4f4f',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const ModalStocks = (props) => {
    const [open, setOpen] = React.useState(false);
    const [art,setArt] = React.useState(props.art)
    const [nme,setNme] = React.useState(props.nme)
    const srrsts=(target)=>{
       console.log(target)
        alert(target)
    }

    function handleChangex(e) {
        setArt(e.target.value);
    }
    const handleOpen = () => setOpen(true);

    const handleOpenx = async () => {
        // alert(art)
        // const response = await axios.get(`${baseUrl_back}/goBananasBot/getStockFromMyBD?article=`+ article)
        const response = await BackServer.addstock(props.nme, art, "all");
        // alert(JSON.stringify(response.dta));
        // alert(response.dta)
        setOpen()
    }
    const handleClose = () => setOpen(false);
    return (
        <div>
            <Button variant="contained" size="medium" block fullWidth onClick={handleOpen}>{props.art}</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {props.nme}
                    </Typography>

                    <TextField
                        sx={{ mt: 2 }}
                        id="outlined-disabled"
                        label="Количество"
                        defaultValue={props.art}
                        value={art}
                        onChange={handleChangex}

                    />
                    <p></p>
                    <Button  sx={{ mt: 2 }} variant="contained" onClick={handleOpenx}>Отравить {art}</Button>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Изменения будут приняты в течении 5 минут
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
};

export default ModalStocks;